'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './referral-give.routes';

export class ReferralGiveComponent {
  constructor(ReferralService, dialogs, $uibModal, $stateParams, Auth, User) {
    'ngInject';
    this.ReferralService = ReferralService;
    this.dialogs = dialogs;

    this.referral = {
      for: -1,
      meta: {
        active: true
      }
    };

    User.query(data => {
      this.recipients = data.filter(user => user.active).map(user => {
        user.fullName = user.firstName + ' ' + user.lastName + ' - ' + user.companyName;
        user.group = "Members";
        return user;
      });

      this.recipients.unshift({group: "Group", fullName: "Best of the Best Network"});
    });
  }

  submitReferral() {
    this.ReferralService.save(this.referral, () => {
      this.dialogs.notify('Your referral has been sent', 'Your referral has been sent.<br/>Thank you!');
      this.testimonial = {
        meta: {
          active: true
        }
      };
    });
  }

}

export default angular.module('conduuApp.referralGive', [uiRouter])
  .config(routes)
  .component('referralGive', {
    template: require('./referral-give.html'),
    controller: ReferralGiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/referral/give/referral-give.component.js